export default "__VITE_ASSET__C4fft$Tv__"